<template>
    <div class="hello-page-wrapper video-player-wrapper fixgraybg">
        <div :class="{'animated zoomOutLeft': videoCompleted}" v-show="!videoSqueeze" class="video-player-background">
            <div class="container-fluid">
                <div class="row">
                    <!--<button @click="showCorporateShare = true">Show Dialog</button>-->
                    <div class="video-player" @mouseleave="addRightHoverWidthClass ? resetClass(true) : resetClass(false)">
                        <div class="left-video-icons" v-show="!hideLeftVideoIcons"></div>
                        <div v-if="currentVideo && playTheVideo" class="reset-video-width" :class="{'enjoy-hover': addEnjoyHoverClass}">
                        <jwplayer id="mainVideoPlayer" :data="currentVideo" :on-complete="onVideoComplete">Loading the player...</jwplayer>
                        </div>
                        <!--/////////////////// right hover icons //////////////////////-->
                        <div class="right-video-icons" @mouseleave="resetClass(true)"
                             :class="{'trailexp' : isTrialExpired, 'right-hover-width': addRightHoverWidthClass, 'right-hover-enjoy': addRightHoverEnjoyClass}"
                             >
                            <div class="icons-hover" :class="{'icon-hover-width': addIconHoverWidthClass}">
                                <ul>
                                    <li v-if="currentStatus.liked === '1'">
                                        <div class="plusicon btn-group">
                                        <button title="Add to Playlist" id="addToPlayerTop" type="button" @click="showPlaylistMenu('addToPlayerTop')" class="dropdown-toggle ellipsis pull-right">
<!--                                            <img src="../assets/playlist-icon.png" class="menuiconbutton" title="Playlist" alt="PLAYLIST"/>-->
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                 width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                        </button>
                                        <ul class="hide">
                                            <li  v-if="getUserPlaylists">
                                                <label>
                                                    <b> Add to ...</b>
                                                </label>
                                            </li>
                                            <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                            <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                <label class="notificationwithcheckboxes">
                                                    <input type="checkbox" :checked="verifyVideoExists(playlist, currentVideo)" @click="setPlaylistVideoStatus(currentVideo, playlist, verifyVideoExists(playlist, currentVideo)) "/> {{playlist.title}}
                                                    <transition name="fade">
                                                        <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                        <span class="added" v-if="currentVideo.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                    </transition>
                                                    <transition name="fade">
                                                        <span class="removed" v-if="currentVideo.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                    </transition>
                                                </label>
                                            </li>
                                            <!--<li>-->
                                            <!--<label>-->
                                            <!--<input type="checkbox" /> Second option-->
                                            <!--</label>-->
                                            <!--</li>-->
                                            <!--<li>-->
                                            <!--<label>-->
                                            <!--<input type="checkbox" /> Third option-->
                                            <!--</label>-->
                                            <!--</li>-->
                                            <!--<li>-->
                                            <!--<label>-->
                                            <!--<input type="checkbox" /> Forth option-->
                                            <!--</label>-->
                                            <!--</li>-->
                                            <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                            <li><label style="color:#f0617d">Create new playlist</label></li>
                                            <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />
                                                <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                            </label> </li>
                                        </ul>
                                        <div class="backdropformenu"  @click="hidePlaylistMenu('addToPlayerTop')"></div>
                                    </div>
                                    <a href="javascript:">
                                            <i class="fa fa-heart pink-filled" v-bind:style="{ color: getCorpHeaderColor}" aria-hidden="true" @click="setUserLike()"></i>
                                        </a>
                                    </li>
                                    <li v-else>
                                        <div class="plusicon btn-group">
                                            <button title="Add to Playlist" id="addToPlayerTop" type="button" @click="showPlaylistMenu('addToPlayerTop')" class="dropdown-toggle ellipsis pull-right">
<!--                                                <img src="../assets/playlist-icon.png" class="menuiconbutton" title="Playlist" alt="PLAYLIST"/>-->
                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                     width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                    <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                    <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                    <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                    <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                            </button>
                                            <ul class="hide">
                                                <li  v-if="getUserPlaylists">
                                                    <label>
                                                        <b> Add to ...</b>
                                                    </label>
                                                </li>
                                                <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                    <label class="notificationwithcheckboxes">
                                                        <input type="checkbox" :checked="verifyVideoExists(playlist, currentVideo)" @click="setPlaylistVideoStatus(currentVideo, playlist, verifyVideoExists(playlist, currentVideo)) "/> {{playlist.title}}
                                                        <transition name="fade">
                                                            <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                            <span class="added" v-if="currentVideo.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                        </transition>
                                                        <transition name="fade">
                                                            <span class="removed" v-if="currentVideo.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                        </transition>
                                                    </label>
                                                </li>
                                                <!--<li>-->
                                                <!--<label>-->
                                                <!--<input type="checkbox" /> Second option-->
                                                <!--</label>-->
                                                <!--</li>-->
                                                <!--<li>-->
                                                <!--<label>-->
                                                <!--<input type="checkbox" /> Third option-->
                                                <!--</label>-->
                                                <!--</li>-->
                                                <!--<li>-->
                                                <!--<label>-->
                                                <!--<input type="checkbox" /> Forth option-->
                                                <!--</label>-->
                                                <!--</li>-->
                                                <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                <li><label style="color:#f0617d">Create new playlist</label></li>
                                                <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />
                                                    <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                </label> </li>
                                            </ul>
                                            <div class="backdropformenu"  @click="hidePlaylistMenu('addToPlayerTop')"></div>
                                        </div>
                                        <a href="javascript:">
                                            <i class="fa fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}" aria-hidden="true" @click="setUserLike()"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="rate" @mouseover="changeHeight" href="javascript:">Suggest a TONE Topic</a>
                                    </li>
                                    <li>
                                        <a class="share" @mouseover="showSharing" href="javascript:">Share</a>
                                    </li>
                                    <li>
                                        <a class="enjoy" @mouseover="showEnjoy" href="javascript:">Rating</a>
                                    </li>
                                </ul>
                            </div>
                            <div :class="{'z-index': showRateHoverBox}" class="rate-hover-box" v-show="showRateHoverBox"  v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                                <span>Let us know what topics you want to see on TONE</span>
                                <div v-if="currentStatus.opinion === '1'">
                                    <button  class="btn btn-danger recently-watched-btn btn-transparent btn-lg active" @click="setOpinion('travel')">
                                        <!--<i class="fa fa-smile-o" aria-hidden="true"></i>-->
                                        Travel
                                    </button>
                                </div>
                                <div v-else>
                                    <button  class="btn btn-danger recently-watched-btn btn-transparent btn-lg" @click="setOpinion('travel')">
                                        <!--<i class="fa fa-smile-o" aria-hidden="true"></i>-->
                                        Travel
                                    </button>
                                </div>
                                <div v-if="currentStatus.opinion === '2'">
                                    <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg active" @click="setOpinion('dating')">
                                        <!--<i class="fa fa-user-circle-o" aria-hidden="true"></i>-->
                                        Dating
                                    </button>
                                </div>
                                <div v-else>
                                    <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg" @click="setOpinion('dating')">
                                        <!--<i class="fa fa-user-circle-o" aria-hidden="true"></i>-->
                                        Dating
                                    </button>
                                </div>
                                <div v-if="currentStatus.opinion === '3'">
                                    <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg active" @click="setOpinion('news')">
                                        <!--<i class="fa fa-gift" aria-hidden="true"></i>-->
                                        News
                                    </button>
                                </div>
                                <div v-else>
                                    <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg" @click="setOpinion('news')">
                                        <!--<i class="fa fa-gift" aria-hidden="true"></i>-->
                                        News
                                    </button>
                                </div>
                                <div v-if="currentStatus.opinion === '4'">
                                    <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg active" @click="setOpinion('recipes')">
                                        <!--<i class="fa fa-gift" aria-hidden="true"></i>-->
                                        Recipes
                                    </button>
                                </div>
                                <div v-else>
                                    <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg" @click="setOpinion('recipes')">
                                        <!--<i class="fa fa-gift" aria-hidden="true"></i>-->
                                        Recipes
                                    </button>
                                </div>
                                <!--<button class="btn btn-danger recently-watched-btn btn-transparent btn-lg" @click="setOpinion('notforme')">-->
                                    <!--Not for me-->
                                <!--</button>-->
                            </div>
                            <!--////////////////////////////////////////-->
                            <div :class="{'z-index': showShareHoverBox}" class="share-hover-box" v-show="showShareHoverBox" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                                <!--<a href="javascript:"><i class="fa fa-facebook" aria-hidden="true"></i></a>-->
                                <!--<a href="javascript:"><i class="fa fa-twitter" aria-hidden="true"></i></a>-->
                                <!--<a href="javascript:"><i class="fa fa-pinterest-p" aria-hidden="true"></i></a>-->
                                <!--<a href="javascript:"><i class="fa fa-envelope-o" aria-hidden="true"></i></a>-->
                                <!--<i class="fa fa-caret-left active-arrow" aria-hidden="true"></i>-->
                                <div class="social-share-manage">
                                <social-sharing v-if="currentVideo" v-bind:url = "videoURL" v-bind:media= "videoURL" v-bind:quote = "'TONE Networks | Expert Advice on Demand'" v-bind:description = "currentVideo.Description" v-bind:title = "currentVideo.title" inline-template :class="{ 'control-disabled': isVideoPrivate }">
                                    <div>
                                        <network network="facebook">
                                            <i class="fa fa-2x fa-facebook cursor"></i>
                                        </network>
                                        <network network="twitter">
                                            <i class="fa fa-2x fa-twitter cursor"></i>
                                        </network>
                                        <network network="linkedin" class="holder">
                                            <i class="fa fa-2x fa-linkedin cursor"></i>
                                        </network>
<!--                                        <network network="email" class="holder">-->
<!--                                            <i class="fa fa-2x fa-envelope cursor" @click="showSharedModal=true"></i>-->
<!--                                        </network>-->
                                    </div>
<!--                                    <i v-if="!corporateInfo" class="fa fa-2x fa-envelope cursor" @click="showSharedModal=true"></i>-->
                                </social-sharing>
                                <i title="Share" v-if="((user && user.corporation === null) || (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.shareVideoPermission >= 1))" class="fa fa-2x fa-share-square-o cursor" @click="showSharingModal()"></i>
                                </div>
                                <span v-if="corporateInfo && (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.shareVideoPermission >= 1)" >
                                <a class="popupsharingoptionlink" href="javascript:" @click="showSharingModal()"><i class="fa fa-share-square-o"></i> Share with {{user.isSuperUser ? user.corporationName : corporateInfo.name}}</a>
                                </span>
<!--                                <span v-else>-->
<!--                                   <a class="popupsharingoptionlink" href="javascript:" @click="showSharedModal=true"><i class="fa fa-share-square-o"></i> Share with Friends</a>-->
<!--                                </span>-->
                            </div>
                            <!--////////////////////////////////////////-->
                            <div :class="{'z-index': showEnjoyHoverBox}" class="enjoy-hover-box" v-show="showEnjoyHoverBox" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                                <div class="rating">
                                    <p>So, what did you think?</p>
                                    <div v-if="currentStatus.rating === '1'">
                                        <button  class="btn btn-danger recently-watched-btn btn-transparent btn-lg active" @click="setRating('1')">
                                            <!--<i class="fa fa-smile-o" aria-hidden="true"></i>-->
                                            1 - Not for me
                                        </button>
                                    </div>
                                    <div v-else>
                                        <button  class="btn btn-danger recently-watched-btn btn-transparent btn-lg" @click="setRating('1')">
                                            <!--<i class="fa fa-smile-o" aria-hidden="true"></i>-->
                                            1 - Not for me
                                        </button>
                                    </div>
                                    <div v-if="currentStatus.rating === '2'">
                                        <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg active" @click="setRating('2')">
                                            <!--<i class="fa fa-user-circle-o" aria-hidden="true"></i>-->
                                            2 - Just ok
                                        </button>
                                    </div>
                                    <div v-else>
                                        <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg" @click="setRating('2')">
                                            <!--<i class="fa fa-user-circle-o" aria-hidden="true"></i>-->
                                            2 - Just ok
                                        </button>
                                    </div>
                                    <div v-if="currentStatus.rating === '3'">
                                        <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg active" @click="setRating('3')">
                                            <!--<i class="fa fa-gift" aria-hidden="true"></i>-->
                                            3 - Worth it
                                        </button>
                                    </div>
                                    <div v-else>
                                        <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg" @click="setRating('3')">
                                            <!--<i class="fa fa-gift" aria-hidden="true"></i>-->
                                            3 - Worth it
                                        </button>
                                    </div>
                                    <div v-if="currentStatus.rating === '4'">
                                        <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg active" @click="setRating('4')">
                                            <!--<i class="fa fa-gift" aria-hidden="true"></i>-->
                                            4 - Spot on
                                        </button>
                                    </div>
                                    <div v-else>
                                        <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg" @click="setRating('4')">
                                            <!--<i class="fa fa-gift" aria-hidden="true"></i>-->
                                            4 - Spot on
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--/////////////////// right hover icons //////////////////////-->
                    </div>
                </div>
            </div>
        </div>
        <div v-if="videoSqueeze" class="watch-again">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <p class="congratz">
                            <button class="btn btn-danger backtohomebutton btn-transparent btn-lg" @click="redirectToHome()">Back to Home Page</button>
                            <br />
                            {{videoMessage}}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5 col-lg-6">
                        <div class="current-video-img">
                            <div class="responsiveSocialIcon">
                                <img src="../assets/fireworkssmall.png" :alt="currentVideo.title" v-if="videoGifIndex === 0">
                                <img src="../assets/baloonssmall.png" :alt="currentVideo.title" v-if="videoGifIndex === 1">
                                <img src="../assets/confettismall.png" :alt="currentVideo.title" v-if="videoGifIndex === 2">
                                <img src="../assets/sparkelssmall.gif" :alt="currentVideo.title" v-if="videoGifIndex === 3">

                                <div v-if="currentVideo" class="responsiveSocialIconBox">
                                    <social-sharing v-bind:url = "videoURL" v-bind:media= "videoURL" v-bind:quote = "'TONE Networks | Expert Advice on Demand'" v-bind:description = "currentVideo.Description" v-bind:title = "currentVideo.title" :class="{ 'control-disabled': isVideoPrivate }" inline-template>
                                        <div>
                                            <network network="facebook">
                                                <i class="fa fa-2x fa-facebook cursor"></i>
                                            </network>
                                            <network network="twitter">
                                                <i class="fa fa-2x fa-twitter cursor"></i>
                                            </network>
                                            <network network="linkedin" class="holder">
                                                <i class="fa fa-2x fa-linkedin cursor"></i>
                                            </network>
<!--                                            <network network="email" class="holder">-->
<!--                                                <i class="fa fa-2x fa-envelope cursor"></i>-->
<!--                                            </network>-->
                                        </div>
                                    </social-sharing>
                                </div>
                            </div>
                            <a class="btn btn-link" @click="replayVideo">
                                <i class="glyphicon glyphicon-play"></i> &nbsp;&nbsp; watch again
                            </a>
                            <i v-if="currentStatus.liked === '1'" class="cursor fa fa-heart heartIcon" v-bind:style="{ color: getCorpHeaderColor}"
                               @click="setUserLike()" aria-hidden="true"></i>
                            <i v-else class="cursor fa fa-heart-o heartIcon" v-bind:style="{ color: getCorpHeaderColor}"
                               @click="setUserLike()" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="col-md-7 col-lg-6">
                        <div class="rating">
                            <ul class="chart-skills">
                                <li  @click="setRatingChart('1')" v-bind:class="{ 'active-icon': applyRatingClass('1')}">
                                    <span>Not for me</span>
                                </li>
                                <li @click="setRatingChart('2')"v-bind:class="{ 'active-icon': applyRatingClass('2')}">
                                    <span>Just ok</span>
                                </li>
                                <li @click="setRatingChart('3')" v-bind:class="{'active-icon': applyRatingClass('3')}">
                                    <span>Worth it</span>
                                </li>
                                <li  @click="setRatingChart('4')" v-bind:class="{ 'active-icon': applyRatingClass('4')}">
                                    <span>Spot on</span>
                                </li>
                            </ul>
                            <transition name="bounce">
                            <h2 class="pinkh2" v-if="showRatingMessage">Thanks for your feedback!</h2>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div v-if="!videoCompleted" class="container">-->
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="player-content">
                        <h4>{{currentVideo.title}}</h4>
                        <div class="text-right mobileiconholder" v-if="getCorpButtonColor === '#f0617d'">
                        <ul class="mobilesocialicons">
                            <li v-if="currentStatus.liked === '1'">
                                <a href="javascript:">
                                    <i class="fa fa-heart pink-filled"  aria-hidden="true" @click="setUserLike()"></i>
                                </a>
                            </li>
                            <li v-else>
                                <a href="javascript:">
                                    <i class="fa fa-heart-o"  aria-hidden="true" @click="setUserLike()"></i>
                                </a>
                            </li>
<!--                            <li v-if="corporateInfo && (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.shareVideoPermission >= 1)">-->
<!--                                <a href="javascript:">-->
<!--                                    <i class="fa fa-share-square-o" aria-hidden="true" @click="handleCorporateShareModal()"></i>-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li v-if="!corporateInfo">-->
<!--                                <a href="javascript:">-->
<!--                                    <i class="fa fa-share-square-o" aria-hidden="true" @click="showSharedModal=true"></i>-->
<!--                                </a>-->
<!--                            </li>-->
                            <li>
                                <div class="plusicon btn-group">
                                    <button title="Add to Playlist" :id="currentVideo.mediaid" type="button" @click="showPlaylistMenu(currentVideo.mediaid)" class="dropdown-toggle ellipsis pull-right">
                                        <img src="../assets/playlist-icon.png" class="menuiconbutton" title = "Playlist" alt="PLAYLIST"/>
                                    </button>
                                    <ul class="hide">
                                        <li  v-if="getUserPlaylists">
                                            <label>
                                                <b> Add to ...</b>
                                            </label>
                                        </li>
                                        <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                        <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                            <label class="notificationwithcheckboxes">
                                                <input type="checkbox" :checked="verifyVideoExists(playlist, currentVideo)" @click="setPlaylistVideoStatus(currentVideo, playlist, verifyVideoExists(playlist, currentVideo)) "/> {{playlist.title}}
                                                <transition name="fade">
                                                    <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                    <span class="added" v-if="currentVideo.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                </transition>
                                                <transition name="fade">
                                                    <span class="removed" v-if="currentVideo.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                </transition>
                                            </label>
                                        </li>
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Second option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Third option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Forth option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                        <li><label style="color:#f0617d">Create new playlist</label></li>
                                        <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />
                                            <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                        </label> </li>
                                    </ul>
                                    <div class="backdropformenu"  @click="hidePlaylistMenu(currentVideo.mediaid)"></div>
                                </div>
                            </li>
                        </ul>
                        <social-sharing v-if="currentVideo" v-bind:url = "videoURL" v-bind:media= "videoURL" v-bind:quote = "currentVideo.title" v-bind:description = "currentVideo.Description" v-bind:title = "currentVideo.title" :class="{ 'control-disabled': isVideoPrivate }" inline-template>
                            <div >
                                <network network="facebook">
                                    <i class="fa fa-2x fa-facebook cursor"></i>
                                </network>
                                <network network="twitter">
                                    <i class="fa fa-2x fa-twitter cursor"></i>
                                </network>
                                <network network="linkedin" class="holder">
                                    <i class="fa fa-2x fa-linkedin cursor"></i>
                                </network>
<!--                                <network network="email" class="holder">-->
<!--                                    <i class="fa fa-2x fa-envelope cursor"></i>-->
<!--                                </network>-->
                            </div>
                        </social-sharing>
                            <i v-if="((user && user.corporation === null) || (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.shareVideoPermission >= 1))" class="fa fa-2x fa-share-square-o cursor" aria-hidden="true" @click="showSharingModal()"></i>
                        </div>
                        <div class="text-right mobileiconholder" v-if="getCorpButtonColor !== '#f0617d'">
                            <ul class="mobilesocialicons">
                                <li v-if="currentStatus.liked === '1'" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                    <a href="javascript:">
                                        <i class="fa fa-heart pink-filled"  aria-hidden="true" @click="setUserLike()" v-bind:style="{backgroundColor: '#A9A9A9 !important'}"></i>
                                    </a>
                                </li>
                                <li v-else>
                                    <a href="javascript:">
                                        <i class="fa fa-heart-o"  aria-hidden="true" @click="setUserLike()" v-bind:style="{backgroundColor: '#A9A9A9 !important'}"></i>
                                    </a>
                                </li>
                                <!--                            <li v-if="corporateInfo && (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.shareVideoPermission >= 1)">-->
                                <!--                                <a href="javascript:">-->
                                <!--                                    <i class="fa fa-share-square-o" aria-hidden="true" @click="handleCorporateShareModal()"></i>-->
                                <!--                                </a>-->
                                <!--                            </li>-->
                                <!--                            <li v-if="!corporateInfo">-->
                                <!--                                <a href="javascript:">-->
                                <!--                                    <i class="fa fa-share-square-o" aria-hidden="true" @click="showSharedModal=true"></i>-->
                                <!--                                </a>-->
                                <!--                            </li>-->
                                <li>
                                    <div class="plusicon btn-group" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                        <button title="Add to Playlist" :id="currentVideo.mediaid" type="button" @click="showPlaylistMenu(currentVideo.mediaid)" class="dropdown-toggle ellipsis pull-right" >
                                            <img src="../assets/playlist-icon.png" class="menuiconbutton" title = "Playlist" alt="PLAYLIST"/>
                                        </button>
                                        <ul class="hide">
                                            <li  v-if="getUserPlaylists">
                                                <label>
                                                    <b> Add to ...</b>
                                                </label>
                                            </li>
                                            <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                            <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                <label class="notificationwithcheckboxes">
                                                    <input type="checkbox" :checked="verifyVideoExists(playlist, currentVideo)" @click="setPlaylistVideoStatus(currentVideo, playlist, verifyVideoExists(playlist, currentVideo)) "/> {{playlist.title}}
                                                    <transition name="fade">
                                                        <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                        <span class="added" v-if="currentVideo.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                    </transition>
                                                    <transition name="fade">
                                                        <span class="removed" v-if="currentVideo.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                    </transition>
                                                </label>
                                            </li>
                                            <!--<li>-->
                                            <!--<label>-->
                                            <!--<input type="checkbox" /> Second option-->
                                            <!--</label>-->
                                            <!--</li>-->
                                            <!--<li>-->
                                            <!--<label>-->
                                            <!--<input type="checkbox" /> Third option-->
                                            <!--</label>-->
                                            <!--</li>-->
                                            <!--<li>-->
                                            <!--<label>-->
                                            <!--<input type="checkbox" /> Forth option-->
                                            <!--</label>-->
                                            <!--</li>-->
                                            <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                            <li><label style="color:#f0617d">Create new playlist</label></li>
                                            <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />
                                                <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                            </label> </li>
                                        </ul>
                                        <div class="backdropformenu"  @click="hidePlaylistMenu(currentVideo.mediaid)"></div>
                                    </div>
                                </li>
                            </ul>
                            <social-sharing v-if="currentVideo" v-bind:url = "videoURL" v-bind:media= "videoURL" v-bind:quote = "currentVideo.title" v-bind:description = "currentVideo.Description" v-bind:title = "currentVideo.title" :class="{ 'control-disabled': isVideoPrivate }" inline-template>
                                <div >
                                    <network network="facebook" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                        <i class="fa fa-2x fa-facebook cursor" v-bind:style="{color: '#FFFFFF !important'}"></i>
                                    </network>
                                    <network network="twitter" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                        <i class="fa fa-2x fa-twitter cursor" v-bind:style="{color: '#FFFFFF !important'}"></i>
                                    </network>
                                    <network network="linkedin" class="holder" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                        <i class="fa fa-2x fa-linkedin cursor" v-bind:style="{color: '#FFFFFF !important'}"></i>
                                    </network>
                                    <!--                                <network network="email" class="holder">-->
                                    <!--                                    <i class="fa fa-2x fa-envelope cursor"></i>-->
                                    <!--                                </network>-->
                                </div>
                            </social-sharing>
                            <i v-if="((user && user.corporation === null) || (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.shareVideoPermission >= 1))" class="fa fa-2x fa-share-square-o cursor" aria-hidden="true" @click="showSharingModal()" v-bind:style="{backgroundColor: '#A9A9A9 !important'}"></i>
                        </div>
                        <div class="clearfix"></div>
                        <p>
                            {{currentVideo.Description}}
                        </p>
                        <div class="profile-content" v-if="getExpert">
                            <a :href="'/expert/' + getExpert[0].expertId + '/' + getExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" target="_blank">
                            <img v-bind:src="getExpert[0].small_image" :alt="getExpert[0].name" :title="getExpert[0].name">
                            <h4>{{getExpert && getExpert[0].name}}</h4>
                            <span>{{getExpert && getExpert[0].experties}}</span>
                            </a>
                        </div>
                        <p class="video-text">
                            {{getExpert && getExpert[0].areasofexpertise}}
                        </p>
<!--                        :style="styleObject" @mouseenter="updateHoverState(true)" @mouseleave="updateHoverState(false)"-->
<!--                        v-bind:style="[viewTranscript ? { color: '#FFFFFF !important', backgroundColor: this.getCorpButtonColor, border: '2px solid' + this.getCorpButtonColor + ' !important', outline: 'none !important'} : { color: getCorpButtonColor, backgroundColor: '#FFFFFF', border: '2px solid' + this.getCorpButtonColor + ' !important', outline: 'none !important'}]"&ndash;&gt;-->
                        <div class="row" v-if="!isTrialExpired">
                            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">
                                <button class="btn recently-watched-btn btn-transparent btn-lg"
                                        @click="toggleViewTranscript"
                                        v-bind:style="[viewTranscript ? { color: '#FFFFFF !important', backgroundColor: this.getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important', outline: 'none !important'} : { color: getCorpButtonColor + ' !important', backgroundColor: '#FFFFFF !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important', outline: 'none !important'}]"
                                >
                                    <span v-show="!viewTranscript">View Transcript</span>
                                    <span v-show="viewTranscript">Hide Transcript</span>
                                </button>
                            </div>
                            <div class="col-xs-12 col-sm-8 col-md-8 col-lg-9 vtrnscript">
                                <div class="side-content" v-if="getCurrentVideoTranscript"
                                     v-bind:style="{ 'border-left-color': this.getCorpHeaderColor + ' !important'}">
                                    <div v-show="viewTranscript" class="boxes"
                                         :class="{'animated fadeIn': viewTranscript, 'animated fadeOut': !viewTranscript}"
                                         >
                                        <pre><p v-html="getCurrentVideoTranscript.vtt_file">
                                        </p></pre>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--<div class="profile-content" v-if="getExpert">-->
                            <!--<img v-bind:src="getExpert[0].small_image" alt="">-->
                            <!--<h4>{{getExpert[0].name}}</h4>-->
                            <!--<span>{{getExpert[0].experties}}</span>-->
                        <!--</div>-->
                        <!--<p class="video-text">-->
                            <!--{{getExpert[0].biography}}-->
                        <!--</p>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="recently-watched">
            <div class="container">
                <div class="row" v-if="getAuthRecommendedVideos && !isTrialExpired">
                    <div class="col-md-12">
                        <h2>RELATED VIDEOS</h2>
                    </div>
                    <div class="col-md-12">
                        <div class="content">
                            <VueSlickCarousel v-bind="carouselSettings" v-if="recommendationList">
                                <div v-for = "reccentVideo in recommendationList">
                                    <div class="slide-player">
                                        <a :href="'/watch/' + reccentVideo.mediaid + '/' + reccentVideo.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                            <img class="jw-img" :src="reccentVideo.image"  :title="reccentVideo.title" :alt="reccentVideo.title"/>
                                            <p class="text-wrap-title">
                                                <i class="fa fa-play-circle-o"></i> {{reccentVideo.title}}
                                            </p>
                                        </a>
                                        <!--<hr>-->
                                        <!--<p class="right-heart-icon">-->
                                        <!--<i class="fa fa-2x fa-heart-o"-->
                                        <!--v-bind:class="{'activeIcons': getVideoStatus(reccentVideo)}" aria-hidden="true" @click=""></i>-->
                                        <!--</p>-->
                                    </div>
                                </div>
                            </VueSlickCarousel>
<!--                            <div class="slider responsive-slick-slider">-->
<!--                                <div v-for = "reccentVideo in recommendationList">-->
<!--                                    <div class="slide-player">-->
<!--                                        <a :href="'/watch/' + reccentVideo.mediaid" class="nounderline">-->
<!--                                        <img class="jw-img" :src="reccentVideo.image"  :title="reccentVideo.title" :alt="reccentVideo.title"/>-->
<!--                                        <p class="text-wrap-title">-->
<!--                                            <i class="fa fa-play-circle-o"></i> {{reccentVideo.title}}-->
<!--                                        </p>-->
<!--                                        </a>-->
<!--                                        &lt;!&ndash;<hr>&ndash;&gt;-->
<!--                                        &lt;!&ndash;<p class="right-heart-icon">&ndash;&gt;-->
<!--                                            &lt;!&ndash;<i class="fa fa-2x fa-heart-o"&ndash;&gt;-->
<!--                                               &lt;!&ndash;v-bind:class="{'activeIcons': getVideoStatus(reccentVideo)}" aria-hidden="true" @click=""></i>&ndash;&gt;-->
<!--                                        &lt;!&ndash;</p>&ndash;&gt;-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                    </div>
                    <div class="col-md-12">
                        <button @click="redirectToRelatedVideos()" class="btn btn-danger recently-watched-btn btn-transparent btn-lg" :style="styleObject" @mouseenter="updateHoverState(true)" @mouseleave="updateHoverState(false)">View All Your Videos</button>
<!--                        <button @click="redirectToRelatedVideos()" class="btn btn-danger recently-watched-btn btn-transparent btn-lg" :style="styleObject" @mouseenter="updateHoverState(true)" @mouseleave="updateHoverState(false)">View All Your Videos</button>-->
                    </div>
                </div>
            </div>
        </div>
        <modal v-if="showMemberOverlay" class="watchVideoModal" effect="zoom" :value="showMemberOverlay" @cancel="cancelMemberModal()">
            <div slot="modal-header" class="watchVideoModalHeader">
                <a href="javascript:">
                    <img src="../assets/logo.svg" alt="LOGO">
                </a>
                <a href="javascript:" @click="cancelMemberModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <p><b>We hope you're enjoying your free access to TONE Lite, a limited preview experience!</b> </p>
                <p><b>In order to customize your viewing and to be able to produce videos relevant to you, we occasionally need to ask you to update your subscription information</b></p>
                <div class="text-center">
                    <button class="btn formButton btn-transparent" id="videoplayer_videoredirect" @click="$router.push('/becomemember')">
                        Update my Membership
                    </button><br>
                    <button class="btn formButton btn-transparent" id="videoplayer_videostay" @click="cancelMemberModal()">
                        Not right now, take me to free video
                    </button>
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
        <modal v-if="showCorporateShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateShare" @cancel="cancelCorporateModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i class="fa fa-share-square-o"></i> Share with your Corporate Community Or Friends
                <a href="javascript:" @click="cancelCorporateModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                <select v-model="shareOption" class="form-control strongselec">
                    <option value="Corporate" v-if="showShareCommunity">Share with Community</option>
                    <option value="Individual" v-if="showShareIndividual">Share with Colleagues</option>
                    <option value="Friends" v-if="showShareFriends">Share with Friends</option>
                </select>
                </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
<!--                            <td>-->
<!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
<!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <textarea v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="currentVideo.img" :title="currentVideo.title" :alt="currentVideo.title">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${currentVideo.title} | TONE Networks`}}</h4>
                        <p> {{`${currentVideo.Description.substring(0,250)}...`}}</p>
                    </div>
                </div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button  v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess)) " @click="shareCorporateVideo()">
                            Share this video
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
        <modal v-if="showSharedModal" class="watchVideoModal" effect="zoom" :value="showSharedModal" @cancel="cancelEmailShareModal()">
            <div slot="modal-header" class="watchVideoModalHeader">
                <a href="javascript:">
                    <img src="../assets/logo.svg" alt="LOGO">
                </a>
                <a href="javascript:" @click="cancelEmailShareModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="form">
                    <form method="post" id="playlistshare-form" v-on:submit.prevent="onSharePlaylist" autocomplete="off">
                        <multiselect v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                        <bs-input v-model="sharePayload.sharedEmailMessage"
                                  name="playlistshare_sharedMessage"
                                  id = "playlistshare_sharedMessage"
                                  type="text"
                                  class="form-input"
                                  error="Optional Message"
                                  placeholder="Optional Message"
                                  autocomplete="off"
                                  icon>
                        </bs-input>
                        <bs-input v-model="sharePayload.sharedPlaylistPreview"
                                  name="playlistshare_sharedEmailMessagePreview"
                                  id="playlistshare_sharedEmailMessagePreview"
                                  type="textarea"
                                  disabled
                                  class="form-input"
                                  placeholder=""
                        >
                        </bs-input>
                        <button type="submit"  class="btn formButton btn-block" :disabled="spinner || (taggedEmails && taggedEmails.length === 0)">
                            Send Email
                            <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </form>
                </div>
            </div>
            <div slot="modal-footer">
            </div>
        </modal>
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayList.vue'
    import slick from 'slick-carousel'
    import { mapGetters } from 'vuex'
    import { modal, spinner, input } from 'vue-strap'
    import $ from 'jquery'
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    export default {
        name: 'player',
        components: {
            jwplayer,
            'jwplaylist': JwPlayList,
            'bs-input': input,
            modal: modal,
            spinner,
            VueSlickCarousel
        },
        metaInfo () {
            let self = this
            return {
                title: 'TONE Video | ' + self.currentVideo.title,
                meta: [
                    {property: 'og:image', content: self.currentVideo.img},
                    {property: 'og:title', content: self.currentVideo.title + ' | TONE Networks'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: self.currentVideo.Description
                    },
                    {property: 'twitter:title', content: self.currentVideo.title + ' | TONE Networks'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.currentVideo.img},
                    {
                        property: 'twitter:description',
                        content: self.currentVideo.Description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                carouselSettings: {
                    'dots': false,
                    'infinite': true,
                    'speed': 500,
                    'slidesToShow': 3,
                    'slidesToScroll': 1,
                    'initialSlide': 0,
                    'responsive': [
                        {
                            'breakpoint': 1024,
                            'settings': {
                                'slidesToShow': 1,
                                'slidesToScroll': 1,
                                'infinite': true,
                                'dots': true
                            }
                        },
                        {
                            'breakpoint': 600,
                            'settings': {
                                'slidesToShow': 1,
                                'slidesToScroll': 1,
                                'initialSlide': 2
                            }
                        },
                        {
                            'breakpoint': 480,
                            'settings': {
                                'slidesToShow': 1,
                                'slidesToScroll': 1
                            }
                        }
                    ]
                },
                options: [
                    { name: 'Vue.js', code: 'vu' },
                    { name: 'Javascript', code: 'js' },
                    { name: 'Open Source', code: 'os' }
                ],
                playTheVideo: true,
                hoverState: false,
                hoverStateTranscript: false,
                showShareCommunity: false,
                showShareIndividual: false,
                showShareFriends: false,
                taggedEmails: [],
                emailList: [],
                previewMsg: 'Message Preview: \n',
                showSharedModal: false,
                shareInProcess: false,
                activeTab: 0,
                currentVideo: '',
                currentStatus: '',
                currentVideoCode: this.$route.params.videoCode,
                recommendationList: '',
                videoCompleted: false,
                videoSqueeze: false,
                hideLeftVideoIcons: false,
                addRightHoverWidthClass: false,
                addIconHoverWidthClass: false,
                showRateHoverBox: false,
                showShareHoverBox: false,
                showEnjoyHoverBox: false,
                addRightHoverEnjoyClass: false,
                addEnjoyHoverClass: false,
                captionTrack: '',
                viewTranscript: false,
                ratingOne: false,
                ratingTwo: false,
                ratingThree: false,
                ratingFour: false,
                hideAll: false,
                videoMessage: '',
                videoMessageIndex: Math.floor(Math.random() * 7),
                videoGif: '',
                videoGifIndex: Math.floor(Math.random() * 4),
                videoURL: window.location.href,
                newPlaylistName: '',
                videoAdded: false,
                videoRemoved: false,
                selectedVideo: 0,
                selecedPlaylist: 0,
                isTrialExpired: false,
                showMemberOverlay: false,
                showRatingMessage: false,
                showCorporateShare: false,
                shareOption: 'Corporate',
                corporateShareMessage: '',
                corporateInfo: null,
                selectedCorps: null,
                sharingMessage: '',
                spinner: false,
                isVideoPrivate: false,
                shareVideoPayload: {
                    corporationId: 0,
                    recipientFriendEmails: null,
                    senderUserId: 0,
                    recipientsUserIds: [],
                    videoCode: '',
                    messageText: ''
                },
                sharePayload: {
                    tmpVideCode: '',
                    sharedEmailList: '',
                    sharedEmailMessage: '',
                    sharedPlaylistPreview: ''
                },
                allCorps: [
                    { name: 'Ann Carlsen', corporationId: '1' },
                    { name: 'Jet Blue', corporationId: '2' },
                    { name: 'AMC Networks', corporationId: '3' }
                ]
            }
        },
        watch: {
            'sharePayload.sharedEmailMessage' (to, from) {
                let self = this
                // self.sharePayload.sharedPlaylistPreview = `${self.user.firstName} ${self.user.lastName} shared a playlist with you on TONE Networks: \n ${self.sharePayload.sharedPlaylistTitle} \n`
                let oriiginalMessage = `${self.user.firstName} ${self.user.lastName} shared a video with you on TONE Networks: \n${self.currentVideo.title} \n`
                if (self.showSharedModal && (self.sharePayload.sharedEmailMessage && self.sharePayload.sharedEmailMessage.length > 0)) {
                    self.sharePayload.sharedPlaylistPreview = `${self.previewMsg}${oriiginalMessage}${self.sharePayload.sharedEmailMessage}`
                } else {
                    self.sharePayload.sharedPlaylistPreview = `${self.previewMsg}${self.user.firstName} ${self.user.lastName} shared a video with you on TONE Networks: \n${self.currentVideo.title} \n`
                }
            },
            'showCorporateShare' (to, from) {
                let self = this
                if (self.showCorporateShare) {
                    self.selectedCorps = null
                    self.corporateShareMessage = ''
                    self.taggedEmails = []
                }
            },
            'shareOption' (to, from) {
                let self = this
                self.selectedCorps = null
                self.corporateShareMessage = ''
                self.taggedEmails = []
            }
        },
        methods: {
            updateHoverState (isHover) {
                this.hoverState = isHover
            },
            updateHoverStateTranscript (isHover) {
                this.hoverStateTranscript = isHover
            },
            showSharingModal () {
                let self = this
                if (self.user && self.user.corporation === null) {
                    self.showSharedModal = true
                } else {
                    self.showCorporateShare = true
                    if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareVideoPermission >= 1) {
                        let rights = self.user.corporation.corpSharingPermissions.shareVideoPermission
                        console.log('rights', rights)
                        if (rights === 1) {
                            self.showShareCommunity = true
                            self.showShareIndividual = true
                            self.showShareFriends = true
                        } else if (rights === 2) {
                            self.showShareCommunity = true
                            self.showShareIndividual = false
                            self.showShareFriends = false
                            self.shareOption = 'Corporate'
                        } else if (rights === 3) {
                            self.showShareCommunity = false
                            self.showShareFriends = false
                            self.showShareIndividual = true
                            self.shareOption = 'Individual'
                        } else if (rights === 5) {
                            self.showShareCommunity = false
                            self.showShareIndividual = false
                            self.showShareFriends = true
                            self.shareOption = 'Friends'
                        } else {
                            self.showShareCommunity = false
                            self.showShareIndividual = false
                            self.showShareFriends = false
                        }
                    }
                }
            },
            handleCorporateShareModal () {
                let self = this
                self.showCorporateShare = true
                // Set up user rights
                if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareVideoPermission >= 1) {
                    let rights = self.user.corporation.corpSharingPermissions.shareVideoPermission
                    console.log('rights', rights)
                    if (rights === 1) {
                        self.showShareCommunity = true
                        self.showShareIndividual = true
                    } else if (rights === 2) {
                        self.showShareCommunity = true
                        self.showShareIndividual = false
                        self.shareOption = 'Corporate'
                        self.showCorporateShare = true
                    } else if (rights === 3) {
                        self.showShareCommunity = false
                        self.showShareIndividual = true
                        self.shareOption = 'Individual'
                    } else {
                        self.showShareCommunity = false
                        self.showShareIndividual = false
                    }
                }
            },
            addTag (newTag) {
                let self = this
                console.log('newTAg', newTag)
                const tag = {
                    name: newTag
                }
                if (self.verifyEmail(newTag)) {
                    self.emailList.push(tag)
                    this.taggedEmails.push(tag)
                    console.log('tagged emails', this.taggedEmails)
                } else {
                    console.log('invalid email address, calling swal')
                    // self.$swal({
                    //     title: 'Invalid Email Address',
                    //     text: 'Please enter valid email address',
                    //     type: 'error',
                    //     timer: 2000,
                    //     showCancelButton: false,
                    //     showConfirmButton: false
                    // }).then(
                    //     function () {
                    //     },
                    //     // handling the promise rejection
                    //     function (dismiss) {
                    //         if (dismiss === 'timer') {
                    //         }
                    //     }
                    // )
                }
            },
            verifyEmail (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyEmailList (emailList) {
                let removeWhiteSpace = emailList.filter(x => {
                    return x.trim()
                })
                let updatedList = removeWhiteSpace.filter(x => {
                    return x !== '' && x !== ' ' && x !== '  '
                })
                let self = this
                let re = /\S+@\S+\.\S+/
                for (let i = 0; i < updatedList.length; i++) {
                    if (updatedList[i] && updatedList[i] !== ' ' && !re.test(updatedList[i])) {
                        self.failedEmail = updatedList[i]
                        return false
                    }
                }
                self.failedEmail = ''
                self.sharePayload.sharedEmailList = updatedList.join(',')
                return true
            },
            cancelEmailShareModal () {
                var self = this
                var $ = window.jQuery
                self.sharePayload.tmpVideCode = ''
                self.sharePayload.sharedEmailList = ''
                self.sharePayload.sharedEmailMessage = ''
                self.sharePayload.sharedPlaylistPreview = `${self.user.firstName} ${self.user.lastName} shared a video with you on TONE Networks: \n${self.currentVideo.title} \n`
                setTimeout(function () {
                    self.showSharedModal = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            onSharePlaylist () {
                let self = this
                self.spinnerToggle()
                let emailArray = self.taggedEmails.map(x => {
                    return x.name
                })
                self.sharePayload.sharedPlaylistPreview = `${self.user.firstName} ${self.user.lastName} shared a video with you on TONE Networks: \n${self.currentVideo.title}\n${self.sharePayload.sharedEmailMessage}`
                let sharePayload = {
                    csvEmailRecepients: emailArray.join(','),
                    userId: self.user.userId,
                    tmpVideCode: self.$route.params.videoCode,
                    customizedMessage: self.sharePayload.sharedPlaylistPreview
                }
                self.$store.dispatch('EMAILSHAREVIDEO', {payload: sharePayload}).then(() => {
                    if (!self.error.show) {
                        self.spinnerToggle()
                        self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                            if (self.getTaggedEmailList) {
                                self.emailList = []
                                self.emailList = self.getTaggedEmailList
                                self.taggedEmails = []
                                self.sharePayload.sharedPlaylistPreview = ''
                            }
                        })
                        self.$swal({
                            title: 'Email Sent!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        self.cancelEmailShareModal()
                    } else {
                        self.spinnerToggle()
                        self.cancelEmailShareModal()
                    }
                })
            },
            maskEmailAddress (userEmail) {
                let avg, splitted, part1, part2
                splitted = userEmail.split('@')
                part1 = splitted[0]
                let regex = /[^0-9.]/g
                let maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1)
                console.log('maked', maskid)
                avg = part1.length / 2
                part1 = part1.substring(0, (part1.length - avg))
                part2 = splitted[1]
                let maskDomain = part2.split('.')
                return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1]
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            shareCorporateVideo () {
                let self = this
                self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
                self.shareVideoPayload.senderUserId = self.user.userId
                self.shareVideoPayload.recipientsUserIds = []
                self.shareVideoPayload.recipientFriendEmails = null
                self.shareVideoPayload.messageText = self.corporateShareMessage
                if (self.shareOption === 'Corporate') {
                    self.shareVideoPayload.recipientsUserIds = []
                    self.shareVideoPayload.recipientFriendEmails = null
                } else if (self.shareOption === 'Individual') {
                    self.shareVideoPayload.recipientFriendEmails = null
                    if (self.selectedCorps && self.selectedCorps.length > 0) {
                        let userIdArray = self.selectedCorps.map(x => {
                            return x.userId
                        })
                        self.shareVideoPayload.recipientsUserIds = userIdArray
                    }
                } else if (self.shareOption === 'Friends') {
                    self.shareVideoPayload.recipientsUserIds = []
                    let emailArray = self.taggedEmails.map(x => {
                        return x.name
                    })
                    self.shareVideoPayload.recipientFriendEmails = emailArray.join(',')
                } else {
                }
                self.shareVideoPayload.videoCode = self.currentVideo.mediaid
                console.log('final payload', self.shareVideoPayload)
                self.shareInProcess = true
                // Send the Email
                self.$store.dispatch('VIDEOCORPORATESHARE', {payload: self.shareVideoPayload}).then(() => {
                    if (!self.error.show) {
                        self.spinnerToggle()
                        self.$swal({
                            title: 'Video has been shared!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        // self.spinnerToggle()
                        self.cancelCorporateModal()
                    } else {
                        // self.spinnerToggle()
                        self.cancelCorporateModal()
                    }
                })
            },
            customLabel (option) {
                let findDuplicate = this.allCorps.find(x => {
                    return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId
                })
                if (findDuplicate) {
                    let maskedEmail = this.maskEmailAddress(option.email)
                    return `${option.firstName} ${option.lastName} <${maskedEmail}>`
                } else {
                    return `${option.firstName} ${option.lastName}`
                }
            },
            cancelCorporateModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showCorporateShare = false
                    self.shareInProcess = false
//                    let videoReference = window['currentVideoId']
//                    window.jwplayer(videoReference).pause(false)
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            cancelMemberModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showMemberOverlay = false
                    let videoReference = window['currentVideoId']
                    window.jwplayer(videoReference).pause(false)
                    $('.modal-open').removeClass('modal-open')
                }, 500)
                /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                let videoReference = window['currentVideoId']
                window.jwplayer(videoReference).pause(false)
            },
            toggleViewTranscript () {
                this.viewTranscript = !this.viewTranscript
            },
            redirectToRelatedVideos () {
                this.$router.push(`/relatedvideos`)
            },
            onVideoComplete () {
                let self = this
                // show rating view and squeeze the played video and hide rest of the other content
                // this.viewTranscript = false
                if (!self.isTrialExpired) {
                    self.toggleVideoCompleted()
                    self.currentStatus.watched = 'F'
                    self.currentStatus.durationWatched = self.getCurrentVideo[0].duration
                    self.currentStatus.userId = this.user.userId
                    self.$store.dispatch('SETVIDEOSTATUS', self.currentStatus).then(() => {
                        self.currentStatus = self.getCurrentStatus
                    })
                }
            },
            setUserLike () {
                // Set Video Duration Details
                let self = this
                if (!self.isTrialExpired) {
                    let watchedDuration, watchedPercentage
                    if (self.getCurrentVideoDurationWatched) {
                        watchedDuration = self.getCurrentVideoDurationWatched.duration
                    } else {
                        watchedDuration = 0
                    }
                    if (watchedDuration > 0) {
                        watchedPercentage = parseInt((watchedDuration / self.getCurrentVideo[0].duration) * 100)
                    } else {
                        watchedPercentage = 0
                    }
                    if (watchedPercentage >= 5) {
                        self.currentStatus.durationWatched = watchedDuration.toString()
                        self.currentStatus.watched = 'P'
                    } else {
                        self.currentStatus.durationWatched = watchedDuration.toString()
                        self.currentStatus.watched = 'N'
                    }
                    // Set User Like/Dislike
                    if (self.currentStatus.liked === '1') {
                        self.currentStatus.liked = '0'
                    } else {
                        self.currentStatus.liked = '1'
                    }
                    self.currentStatus.userId = self.user.userId
                    self.$store.dispatch('SETVIDEOSTATUS', self.currentStatus).then(() => {
                        self.currentStatus = this.getCurrentStatus
                    })
                }
            },
            setOpinion (desc) {
                // Set Video Duration Details
                let self = this
                if (!self.isTrialExpired) {
                    let watchedDuration, watchedPercentage
                    if (self.getCurrentVideoDurationWatched) {
                        watchedDuration = this.getCurrentVideoDurationWatched.duration
                    }
                    watchedPercentage = parseInt(watchedDuration / parseInt(self.getCurrentVideo[0].duration) * 100)
                    if (watchedPercentage >= 5) {
                        self.currentStatus.durationWatched = watchedDuration.toString()
                        self.currentStatus.watched = 'P'
                    } else {
                        self.currentStatus.durationWatched = watchedDuration.toString()
                        self.currentStatus.watched = 'N'
                    }
                    // Set Opinion
                    let opinion = '0'
                    if (desc === 'travel') {
                        opinion = '1'
                    } else if (desc === 'dating') {
                        opinion = '2'
                    } else if (desc === 'news') {
                        opinion = '3'
                    } else if (desc === 'recipes') {
                        opinion = '4'
                    } else {
                        opinion = '0'
                    }
                    // Uncheck selected optionss
                    if (self.currentStatus.opinion === opinion) {
                        self.currentStatus.opinion = '0'
                    } else {
                        self.currentStatus.opinion = opinion
                    }
                    self.currentStatus.userId = self.user.userId
                    self.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                        self.currentStatus = this.getCurrentStatus
                    })
                }
            },
            setRatingChart (rating) {
                // Set Video Duration Details
                let self = this
                if (!self.isTrialExpired) {
                    self.showRatingMessage = false
                    let watchedDuration, watchedPercentage
                    if (self.getCurrentVideoDurationWatched) {
                        watchedDuration = self.getCurrentVideoDurationWatched.duration
                    }
                    watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100)
                    if (watchedPercentage >= 5) {
                        self.currentStatus.durationWatched = watchedDuration.toString()
                        self.currentStatus.watched = 'P'
                    } else {
                        self.currentStatus.durationWatched = watchedDuration.toString()
                        self.currentStatus.watched = 'N'
                    }
                    // Uncheck selected rating
                    if (self.currentStatus.rating === rating) {
                        self.currentStatus.rating = '0'
                    } else {
                        self.currentStatus.rating = rating
                    }
                    // this.currentStatus.rating = rating
                    self.currentStatus.userId = self.user.userId
                    self.$store.dispatch('SETVIDEOSTATUS', self.currentStatus).then(() => {
                        self.currentStatus = this.getCurrentStatus
                        if (self.currentStatus.rating !== '0' || self.currentStatus.rating === null) {
                            self.showRatingMessage = true
                        }
                    })
                }
            },
            setRating (rating) {
                // Set Video Duration Details
                let self = this
                if (!self.isTrialExpired) {
                    let watchedDuration, watchedPercentage
                    if (self.getCurrentVideoDurationWatched) {
                        watchedDuration = self.getCurrentVideoDurationWatched.duration
                    }
                    watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100)
                    if (watchedPercentage >= 5) {
                        self.currentStatus.durationWatched = watchedDuration.toString()
                        self.currentStatus.watched = 'P'
                    } else {
                        self.currentStatus.durationWatched = watchedDuration.toString()
                        self.currentStatus.watched = 'N'
                    }
                    // Uncheck selected rating
                    if (self.currentStatus.rating === rating) {
                        self.currentStatus.rating = '0'
                    } else {
                        self.currentStatus.rating = rating
                    }
                    // this.currentStatus.rating = rating
                    self.currentStatus.userId = self.user.userId
                    self.$store.dispatch('SETVIDEOSTATUS', self.currentStatus).then(() => {
                        self.currentStatus = this.getCurrentStatus
                        if (self.currentStatus.rating !== '0' || self.currentStatus.rating === null) {
                        }
                    })
                }
            },
            logVideoEntry () {
                let self = this
                if (!self.isTrialExpired) {
                    let logWatchedEntry = {
                        videoCode: this.$route.params.videoCode,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '0',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    }
                    self.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                    })
                }
            },
            setVideoPlayerObject (videoCode) {
                this.$router.push(`/watch/${videoCode}`)
                location.reload()
            },
            applyRatingClass (rating) {
                if (rating === this.currentStatus.rating) {
                    return true
                } else {
                    return false
                }
            },
            setCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $slick.each(function () {
                    // var length = $(this).children().length <= 5
                    $slick.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            },
            toggleVideoCompleted () {
                var self = this
                self.videoCompleted = true
                setTimeout(function () {
                    if (self.showCorporateShare) {
                        self.cancelCorporateModal()
                    }
                    self.videoSqueeze = true
                }, 200)
            },
            replayVideo () {
//                let self = this
                let videoCode = this.$route.params.videoCode
                this.videoCompleted = false
                this.videoSqueeze = false
                this.$router.push(`/watch/${videoCode}`)
                this.setVideoPlayerObject(videoCode)
//                this.created.apply(this)
            },
            changeHeight () {
//                $('.left-video-icons').hide()
//                $('.rate-hover-box').show()
//                $('.right-video-icons').addClass('right-hover-width')
//                $('.icons-hover').addClass('icon-hover-width')
                this.hideLeftVideoIcons = true
                this.showRateHoverBox = true
                this.addRightHoverWidthClass = true
                this.addIconHoverWidthClass = true
                this.showShareHoverBox = false
                this.showEnjoyHoverBox = false
            },
            showSharing () {
//                $('.left-video-icons').hide()
//                $('.share-hover-box').show()
//                $('.right-video-icons').addClass('right-hover-width')
//                $('.icons-hover').addClass('icon-hover-width')
                this.hideLeftVideoIcons = true
                this.showShareHoverBox = true
                this.addRightHoverWidthClass = true
                this.addIconHoverWidthClass = true
                this.showRateHoverBox = false
                this.showEnjoyHoverBox = false
            },
            redirectToHome () {
                this.$router.push('/')
            },
            showEnjoy () {
//                $('.enjoy-hover-box').show()
//                $('.left-video-icons').hide()
//                $('.right-video-icons').addClass('right-hover-enjoy')
//                $('.icons-hover').addClass('icon-hover-width')
//                $('div.reset-video-width').addClass('enjoy-hover')
                this.showEnjoyHoverBox = true
                this.hideLeftVideoIcons = true
                this.addRightHoverEnjoyClass = true
                this.addIconHoverWidthClass = true
                this.addEnjoyHoverClass = true
                this.showRateHoverBox = false
                this.showShareHoverBox = false
            },
            resetClass (bool) {
                if (bool) {
                    this.hideLeftVideoIcons = false
                    this.addRightHoverWidthClass = false
                    this.addRightHoverEnjoyClass = false
                    this.addIconHoverWidthClass = false
                    this.showRateHoverBox = false
                    this.showShareHoverBox = false
                    this.showEnjoyHoverBox = false
                    this.addEnjoyHoverClass = false
                } else {
                }
            },
            getVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0 && exists[0].liked === '1') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            setPlaylistVideoStatus (video, playlist, currentStatus) {
                let self = this
                self.selectedVideo = video.mediaid
                self.selectedPlaylist = playlist.playlistId
                if (currentStatus) { // Video is unSelected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userPlaylistId = playlist.playlistId
                    payload.userId = this.user.userId
                    this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                        self.videoAdded = false
                        self.videoRemoved = true
                    })
                } else { // Video is Selected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userId = this.user.userId
                    payload.userPlaylistId = playlist.playlistId
                    this.$store.dispatch('ADDVIDEOINPLAYLIST', {playlist: payload}).then(() => {
                        // this.charities = this.getAuthUserVideos
                        self.videoAdded = true
                        self.videoRemoved = false
                    })
                }
                setTimeout(() => {
                    self.videoAdded = false
                    self.videoRemoved = false
                }, 1500)
            },
            verifyPlaylistExists () {
                if (this.getUserPlaylists) {
                    let playlistsWithVideo = this.getUserPlaylists.filter(x => {
                        return x.userPlaylistVideos !== null
                    })
                    if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            verifyVideoExists (playlist, video) {
                let self = this
                if (this.getUserPlaylists) {
                    let findPlaylist = this.getUserPlaylists.filter(x => {
                        return x.playlistId === playlist.playlistId
                    })
                    if (findPlaylist && findPlaylist.length > 0) {
                        if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                            let videos = findPlaylist[0].userPlaylistVideos.filter(x => {
                                return x.videoCode === video.mediaid
                            })
                            if (videos && videos.length > 0) {
                                self.playlistHasVideo = true
                                return true
                            } else {
                                return false
                            }
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            addNewPlayList () {
                if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                    let payload = {}
                    payload.userId = this.user.userId
                    payload.title = this.newPlaylistName
                    this.$store.dispatch('CREATEPLAYLIST', {playlist: payload}).then(() => {
                        this.newPlaylistName = ''
                        // this.charities = this.getAuthUserVideos
                    })
                }
            },
            showPlaylistMenu (videoCode) {
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            hidePlaylistMenu (videoCode) {
                // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            updateUserVideoView () {
                let self = this
                if (!self.isTrialExpired) {
                    let watchedDuration, watchedPercentage
                    if (self.getCurrentVideoDurationWatched) {
                        watchedDuration = self.getCurrentVideoDurationWatched.duration
                    }
                    watchedPercentage = parseInt(watchedDuration / parseInt(self.getCurrentVideo[0].duration) * 100)
                    if (watchedPercentage >= 5) {
                        self.currentStatus.durationWatched = watchedDuration.toString()
                        self.currentStatus.watched = 'P'
                    } else {
                        self.currentStatus.durationWatched = watchedDuration.toString()
                        self.currentStatus.watched = 'N'
                    }
                    self.currentStatus.userId = self.user.userId
                    self.$store.dispatch('SETVIDEOSTATUS', self.currentStatus).then(() => {
                        self.currentStatus = this.getCurrentStatus
                    })
                }
            }
        },
        mounted: function () {
            // Retreive Video Object
            let self = this
            // Log User entry in navigation
            let userPayload = []
            let uId = 0
            if (self.user) {
                uId = self.user.userId
            }
            userPayload.push(uId)
            userPayload.push(self.$route.fullPath)
            console.log('user activity', userPayload)
            self.$store.dispatch('LOGUSERACTIVITY', userPayload)
            if (self.getTrialDays < 0) {
                self.isTrialExpired = true
                let parameter = self.$route.params.refBy
                if (parameter && (parameter.toLowerCase() === 'toneteaser' || parameter.toLowerCase() === 'tonetakeaway')) {
                } else {
                    self.$router.push('/mytone')
                }
            }
            // Get Tagged Email List
            self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                if (self.getTaggedEmailList) {
                    self.emailList = []
                    self.emailList = self.getTaggedEmailList
                    console.log('email list', self.getTaggedEmailList)
                }
            })
            if (!self.isTrialExpired) { // Regular user, Trial hasn't expired
                window.addEventListener('beforeunload', this.updateUserVideoView)
                this.$store.dispatch('GETCURRENTVIDEO', this.$route.params.videoCode).then(() => {
                    if (this.getCurrentVideo) {
                        let video = this.getCurrentVideo
                        if (video[0].isPrivate && video[0].isPrivate === '1') {
                            self.isVideoPrivate = true
                            if (self.isVideoPrivate) {
                                if (self.user && self.user.corporation && self.user.corporation.corporationId.toString() === video[0].episode_id.toString()) {
                                // User can view thsi private video since it belongs to same corporation
                                } else {
                                    setTimeout(() => {
                                        this.$swal({
                                            title: `Exclusive Content`,
                                            text: 'Your account doesn\'t have access to this video',
                                            type: 'error',
                                            timer: 3000,
                                            showCancelButton: false,
                                            showConfirmButton: false
                                        }).then(
                                            function () {
                                            },
                                            // handling the promise rejection
                                            function (dismiss) {
                                                if (dismiss === 'timer') {
                                                    self.$router.push('/mytone')
                                                }
                                            }
                                        )
                                    }, 1000)
                                    self.playTheVideo = false
                                }
                            }
                        }
                        console.log('is video private', self.isVideoPrivate)
                        this.currentVideo = {
                            video: video[0].sources[video[0].sources.length - 1].file,
                            title: video[0].title,
                            img: video[0].image,
                            playerID: new Date(),
                            tracks: video[0].tracks,
                            Description: video[0].description,
                            mediaId: video[0].mediaid,
                            mediaid: video[0].mediaid,
                            isPrivate: self.isVideoPrivate
                        }
                        self.$store.dispatch('CACHEPAGE', self.videoURL)
                        this.$store.dispatch('GETEXPERT', video[0].expertid).then(() => {
                        })
                    } else {
                        this.$swal({
                            title: `Video not found`,
                            text: '',
                            type: 'error',
                            timer: 2000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                    self.$router.push('/mytone')
                                }
                            }
                        )
                    }
                })
                // Get Video Transcript
                this.$store.dispatch('GETVIDEOTRANSCRIPT', this.$route.params.videoCode).then(() => {
                })
                // Get Recommended Videos
                this.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', this.user.userId).then(() => {
                    let filteredList = this.getAuthRecommendedVideos.filter(code => {
                        return code.mediaid !== this.currentVideoCode
                    })
                    this.recommendationList = filteredList
                    // setTimeout(() => {
                    //     this.setCarousal()
                    // }, 2000)
                    // this.recommendedVideos = this.getAuthRecommendedVideos
                })
                // Get User Videos Reference
                this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(() => {
                    if (this.getAuthUserVideos) {
                        let code = this.$route.params.videoCode
                        let exists = this.getAuthUserVideos.filter(code => {
                            return code.videoCode === this.currentVideoCode
                        })
                        if (exists && exists.length > 0) {
                            this.currentStatus = exists[0]
                        } else {
                            this.currentStatus = {
                                videoCode: this.$route.params.videoCode,
                                userId: this.user.userId,
                                playlistId: null,
                                playlistCode: null,
                                watched: 'N',
                                rating: null,
                                liked: '0',
                                durationWatched: 0,
                                thumbnailURL: null,
                                opinion: null
                            }
                            this.logVideoEntry()
                        }
                        console.log(code)
                    }
                })
                // Get User Playlists
                this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(() => {
                })
                // Get Corporatin Payload if user is part of corporation
                this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(() => {
                    this.allCorps = []
                    if (this.getCorporatePayload) {
                        this.corporateInfo = this.getCorporatePayload
                        this.allCorps = this.corporateInfo.lstCorporationUsers
                    }
                })
                this.videoMessage = this.getVideEndMessage[this.videoMessageIndex]
                this.$root.$on('social_shares_open', function (network, url) {
                    window.logEvents('Video Player Page', 'social share', `Video shared on: ${network}`)
                })
            } else {
                if (this.user && (this.user.corporation && this.user.corporation.corporationId === 90 && this.getTrialDays < 0)) { // If user belongs to NOVO Corporation, redirect it to differen tpage
                    this.$router.push('/become-member-novo')
                } else {
                    self.showMemberOverlay = true
                    self.$store.dispatch('GETCURRENTVIDEO', self.$route.params.videoCode).then(() => {
                        if (self.getCurrentVideo) {
                            self.$store.dispatch('GETPROMOVIDEOFORCODE', self.getCurrentVideo[0].promo_video_code).then(() => {
                                if (self.getPromoVideo) {
                                    let video = self.getPromoVideo
                                    self.currentVideo = {
                                        video: video[0].sources[video[0].sources.length - 1].file,
                                        title: video[0].title,
                                        img: video[0].image,
                                        playerID: new Date(),
                                        tracks: video[0].tracks,
                                        Description: video[0].description,
                                        mediaId: video[0].mediaid,
                                        mediaid: video[0].mediaid
                                    }
                                    self.$store.dispatch('GETEXPERT', video[0].expertid).then(() => {
                                    })
                                    setTimeout(() => {
                                        let videoReference = window['currentVideoId']
                                        window.jwplayer(videoReference).seek(1)
                                        window.jwplayer(videoReference).pause(true)
                                    }, 800)
                                }
                            })
                        }
                    })
                    // Get Recommended Videos
                    this.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', this.user.userId).then(() => {
                        let filteredList = this.getAuthRecommendedVideos.filter(code => {
                            return code.mediaid !== this.currentVideoCode
                        })
                        this.recommendationList = filteredList
                        setTimeout(() => {
                            this.setCarousal()
                        }, 2000)
                        // this.recommendedVideos = this.getAuthRecommendedVideos
                    })
                    // Get User Videos Reference
                    this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(() => {
                        if (this.getAuthUserVideos) {
                            let code = this.$route.params.videoCode
                            let exists = this.getAuthUserVideos.filter(code => {
                                return code.videoCode === this.currentVideoCode
                            })
                            if (exists && exists.length > 0) {
                                this.currentStatus = exists[0]
                            } else {
                                this.currentStatus = {
                                    videoCode: this.$route.params.videoCode,
                                    userId: this.user.userId,
                                    playlistId: null,
                                    playlistCode: null,
                                    watched: 'N',
                                    rating: null,
                                    liked: '0',
                                    durationWatched: 0,
                                    thumbnailURL: null,
                                    opinion: null
                                }
//                            this.logVideoEntry()
                            }
                            console.log(code)
                        }
                    })
                    // Get Corporatin Payload if user is part of corporation
                    this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(() => {
                        this.allCorps = []
                        if (this.getCorporatePayload) {
                            console.log('payload corp', this.getCorporatePayload)
                            this.corporateInfo = this.getCorporatePayload
                            this.allCorps = this.corporateInfo.lstCorporationUsers
                        }
                    })
                    // Get User Playlists
                    this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(() => {
                    })
                    this.videoMessage = this.getVideEndMessage[this.videoMessageIndex]
                    this.$root.$on('social_shares_open', function (network, url) {
                        window.logEvents('Video Player Page', 'social share', `Video shared on: ${network}`)
                    })
                }
            }
           // this.videoGif = this.getVideEndGif[this.videoGifIndex]
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'user', 'error', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert',
                'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getUserPlaylists', 'getPromoVideo', 'getTrialDays', 'getCorporatePayload', 'getCardExpiryDays', 'getTaggedEmailList',
                'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor']
            ),
            styleObject () {
                if (this.hoverState) {
                    return {
                        color: '#FFFFFF',
                        backgroundColor: this.getCorpButtonColor,
                        borderColor: this.getCorpButtonColor
                    }
                } else {
                    return {
                        // border: '2px solid' + this.getCorpButtonColor + ' !important',
                        color: this.getCorpButtonColor,
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: this.getCorpButtonColor
                        // borderColor: this.getCorpButtonColor
                    }
                }
            },
            styleObjectTranscript () {
                if (this.hoverStateTranscript && this.viewTranscript) {
                    return {
                        color: '#FFFFFF',
                        backgroundColor: this.getCorpButtonColor + ' !important',
                        borderColor: this.getCorpButtonColor + ' !important'
                    }
                } else {
                    return {
                        border: '2px solid' + this.getCorpButtonColor + ' !important',
                        color: this.getCorpButtonColor
                    }
                }
            }
        },
        beforeDestroy () {
            let self = this
            if (!self.isTrialExpired) {
                let watchedDuration, watchedPercentage
                if (self.getCurrentVideoDurationWatched) {
                    watchedDuration = self.getCurrentVideoDurationWatched.duration
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(self.getCurrentVideo[0].duration) * 100)
                if (watchedPercentage >= 5) {
                    console.log('percent watch 1 ', watchedPercentage)
                    self.currentStatus.durationWatched = watchedDuration.toString()
                    self.currentStatus.watched = 'P'
                } else {
                    console.log('duration watch 1 ', watchedDuration)
                    self.currentStatus.durationWatched = watchedDuration.toString()
                    self.currentStatus.watched = 'N'
                }
                self.currentStatus.userId = self.user.userId
                self.$store.dispatch('SETVIDEOSTATUS', self.currentStatus).then(() => {
                    self.currentStatus = this.getCurrentStatus
                })
            }
        }
    }
</script>


<style scoped>
    /* Add "scoped" attribute to limit CSS to this component only */
    @media(max-width:767px){
        .text-right.mobileiconholder > i.fa.fa-2x.fa-share-square-o.cursor {
            display: inline-block;
            color: #fff;
            background: #f0617d;
            padding: 0;
            border-radius: 50%;
            height: 42px;
            width: 42px;
            line-height: 46px;
            font-size: 21px;
            text-align: center;
        }
    }
    .social-share-manage {
        width: 160px;
        display: flex;
    }

    .social-share-manage>div {}

    .social-share-manage >i {
        flex: 1;
    }
    .pinkh2{
        color: #f0617d;
    }
    /* Added for message transition */
    .bounce-enter-active {
        animation: bounce-in 1s;
    }
    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }
    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.5);
        }
        100% {
            transform: scale(1);
        }
    }
    /* Change End */
    .video-player-wrapper .watch-again .current-video-img img {
        object-fit: cover;
    }
    .video-player .right-video-icons .enjoy-hover-box {
        width: 20%;
        height: 100%;
        background: #f0617d;
        position: absolute;
        top: 0;
        right: 0;
        padding: 15% 0px 0;
        text-align: left;
    }
    .video-player .right-video-icons .enjoy-hover-box button.btn {
        margin: 0 0 10px;
        border-color: white;
        border-radius: 3px;
        padding: 12px 0 13px;
        display: block;
        width: 80%;
        margin: 0px auto 10px;
        color: #fff;
    }
    .video-player-wrapper .tooltipBox {
        width: 100%;
        text-align: center;
        padding-bottom: 10px;
        height: 35px;
        margin-top: 24px;
    }
    @media (min-width:768px) {
        .video-player .right-video-icons .enjoy-hover-box {
            padding: 117px 0px 0;
        }
        .video-player .right-video-icons .enjoy-hover-box .rating {
            overflow: hidden;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .video-player .right-video-icons .enjoy-hover-box .rating p {
            color: white;
            display: block;
            font-size: 16px;
            letter-spacing: 0.5px;
            margin-top: 23px;
            margin-bottom: 20px;
            padding: 0 10%;
            text-align: center;
        }
    }
    .video-player .right-video-icons .rate-hover-box span {
        margin-bottom: 20px;
    }
    .video-player .right-video-icons .rate-hover-box button:hover {
        background: #ac2925;
    }
    .video-player .btn-danger:focus {
        background: inherit;
        border-color: inherit;
        outline: none;
    }
    .video-player .right-video-icons div button.btn-danger:hover{
        background:rgba(0,0,0,0.1);
    }
    .video-player .right-video-icons div button.btn-danger.active:hover{
        background:#ac2925;
    }
    .video-player .right-video-icons div button.btn-danger.active:focus{
    color: #fff;
    background-color: #ac2925;
    border-color: #fff;
    }
    .profile-content img {
        object-fit: cover;
        object-position: center center;
    }
    .btn-group.plusicon {
        position: absolute;
        right: 50px;
        bottom: 0px;
        height: 29px;
    }
    li.divider {
        border-bottom: 1px solid #ddd;
        margin: 5px -15px;
    }

    button.dropdown-toggle.ellipsis.pull-right {
        background: transparent;
        border: 0 none transparent;
        padding: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right{
        font-size: 21px;
        top: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right li label{
        padding: 30px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+ ul li a {
        padding: 3px 15px;
        margin-bottom: 5px;
        display: block;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control {
        height: 30px;
        padding: 5px 30px 5px 5px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle {
        position: absolute;
        top: 6px;
        font-size:24px;
        right:20px;
        cursor: pointer;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+div + ul li label{
        position:relative;
    }
    button.dropdown-toggle.ellipsis.pull-right+ div + ul,
    button.dropdown-toggle.ellipsis.pull-right+ ul{
        left: 0;
        right: auto;
        width: 230px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 5px;
        top: 100%;
        position: absolute;
        z-index: 5000;
        list-style: none;
        text-align: left;
        padding: 15px;
    }
    .backdropformenu{
        position:fixed;
        z-index:4900;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: transparent;
    }
    .profile .tabContent .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .menuiconbutton{
        height: 24px;
        width: 37px;
    }


    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    label.notificationwithcheckboxes span{
        font-size: 10px;
    }

    span.removed {
        color: red;
    }
    span.added {
        color: #4caa98;
    }

    label.notificationwithcheckboxes {
        position: relative;
        display:block;
    }

    .trailexp .icons-hover {
        display: none;
    }
    button#videoplayer_videoredirect {
        border-radius: 5px;
        font-weight: 700;
    }

    button#videoplayer_videostay {
        background: white;
        color: #44bda8;
        border: 1px solid #44bda8;
        white-space: normal;
        line-height: 1;
        padding: 6px;
        border-radius: 5px;
    }
    .watchVideoModal .modal-dialog .modal-body p {
        padding: 16px 60px 19px 60px;
    }
    .watchVideoModal.modal.zoom.in {
        z-index: 500000;
    }
    .sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader {
        background: #f0617d;
        color: #fff;
        font-size: 25px;
        text-align: left;
        padding: 15px 25px;
        font-weight: 700;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body p{
        padding: 0;
        margin: 0 0 20px;
    }
    .row.sharefb {
        background: #eee;
        margin-left: 0;
        margin-right: 0;
    }

    .row.sharefb > div {
        padding: 5px;
        text-align: left;
    }

    .row.sharefb .col-sm-5 img {
        max-width: 100%;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
        font-size: 14px;
        font-weight: 300;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6 {
        text-transform: uppercase;
        font-size: 12px;
        margin: 10px 0 5px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4 {
        margin: 0 0 5px;
        font-weight:700;
    }
    .row.buttonsinpopup {
        padding-top: 20px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
        background: #fff;
        color: #333;
        border: 1px solid #cacaca;
        width: 100%;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body {
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink {
        background: #f0617d;
        width: 100%;
        margin: 0;
        border: 1px solid #f0617d;
    }
    .usernamenimg.text-left table {
        max-width: 100%;
        margin: 0 0 20px;
        width: 190px;
    }
    a.popupsharingoptionlink {
        display: block;
        color: #fff;
        text-decoration: none;
        max-width: 150px;
        font-size: 18px;
        font-weight: 700;
        padding-top: 15px;
        text-align: center;
    }

    a.popupsharingoptionlink i:before {
        color: #fff;
    }

    a.popupsharingoptionlink i.fa.fa-share-square-o {
        margin: 0;
        font-size: 20px;
        /* display: block; */
    }
    .strongselec{
        font-weight:700;
    }
    @media(max-width:475px){
        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
            padding-left: 0;
            padding-right: 0;
        }
    }
    .showmobile{display:none;}
    @media(max-width:767px){
        .usernamenimg.text-left {
            display: none;
        }
        .showmobile{
            display: block;
        }
        .alert.alert-default {
            background: #eee;
        }

        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
            display: none;
        }
        .sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {
            top: 1px;
            right: -13px;
        }
        .row.sharefb {
            display: flex;
            align-items: center;
        }
    }
    /*Changes for Corporate Share*/

</style>
<style>
    .vtrnscript a{cursor: pointer}
    @media(max-width:767px){
    .sharesmallpink.watchVideoModal span.multiselect__tag {
        white-space: normal;
        width: 100%;
    }
}
    .fixgraybg .video-player .left-video-icons{background:transparent;}



    ul.mobilesocialicons {
        display: inline-block;
        margin: 0;
        font-size: 30px;
        padding: 0;
        float: left;
    }

    ul.mobilesocialicons li {
        display: inline-block;
        margin: 0;
        padding: 0;
        margin-right: 5px;
        float: left;
    }

    ul.mobilesocialicons + div {
        display: inline-block;
    }

    li .plusicon.btn-group {
        position: relative !important;
        top:0;
        left:0;
        right:auto;
        bottom:auto;
    }

    .text-right.mobileiconholder>div>span i{
        font-size:24px;
    }
    .text-right.mobileiconholder>div>span {
        display:inline-block;
        color: #fff;
        background: #f0617d;
        padding: 0;
        border-radius: 50%;
        height: 42px;
        width: 42px;
        line-height: 46px;
        font-size: 21px;
        text-align: center;
    }

    .text-right.mobileiconholder ul.mobilesocialicons > li > a > i {
        color: #fff;
        background: #f0617d;
        padding: 0;
        border-radius: 50%;
        height: 42px;
        width: 42px;
        line-height: 46px;
        font-size: 21px;
        text-align: center;
        float: left;
    }

    .text-right.mobileiconholder ul.mobilesocialicons li .plusicon.btn-group img{
        filter:brightness(10);
        -ms-filter: brightness(10);
        max-width: 28px;
        height:auto;
    }

    .text-right.mobileiconholder ul.mobilesocialicons li .plusicon.btn-group {
        background: #f0617d;
        padding: 0;
        border-radius: 50%;
        height: 42px;
        width: 42px;
        line-height: 1.3;
        font-size: 13px;
        text-align: center;
        float: left;
    }

    .text-right.mobileiconholder ul.mobilesocialicons li .plusicon.btn-group>button.dropdown-toggle.ellipsis.pull-right {
        width: 39px;
        padding: 0;
        line-height: 38px;
    }

    .text-right.mobileiconholder {
        float: right;
    }
    ul.mobilesocialicons li ul li {
        display: block !important;
        float: none;
    }
    .icons-hover img.menuiconbutton {
        height: auto;
        width: 26px;
        float: left;
        top: 4px;
        position: relative;
        filter: brightness(10);
        -ms-filter: brightness(10);
        margin-right: 10px;
    }

    .icons-hover .plusicon.btn-group button.dropdown-toggle.ellipsis.pull-right+ ul {
        left: auto;
        right: 0;
        color: #343434;
    }

    .video-player .right-video-icons .icons-hover button.dropdown-toggle.ellipsis.pull-right+ ul li {
        margin: 0 0 5px;
    }
    @media(min-width:1025px){
        .text-right.mobileiconholder{display:none;}
    }
</style>



// WEBPACK FOOTER //
// VideoPlayer.vue?40eadcb2